import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import ls from 'localstorage-slim';
import { Subject } from 'rxjs';
import { environment } from './../environments/environment';
import { AuthService } from './core/auth/services/auth.service';
import { SpinnerService } from './services/spinner/spinner.service';
import { AppState } from './store';
import { reduxReset } from './store/actions/root/root.actions';
ls.config.encrypt = true;

@Component({
  selector: 'lns-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterContentChecked {
  loading$: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  timer: any;
  time: any;

  constructor(
    private translate: TranslateService,
    private spinner: SpinnerService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private store: Store<AppState>,
    private authService: AuthService
  ) {
    this.translate.addLangs(['en', 'sl']);

    const currentLang = localStorage.getItem('language');

    currentLang
      ? this.translate.setDefaultLang(currentLang)
      : this.translate.setDefaultLang('sl');

    if (environment.production === true) {
      window.onunload = () => {
        ls.remove('Authorization');
        ls.remove('Private-Key');
        ls.remove('client');
        ls.remove('X-Client-Id');
        ls.remove('client-name');
        this.store.dispatch(reduxReset());
      };
    }
  }

  ngOnInit(): void {
    this.inactivityTime();
    this.loading$ = this.spinner.loading$;
  }

  inactivityTime() {
    window.onload = this.resetTimer.bind(this);
    // DOM Events
    document.onmousemove = this.resetTimer.bind(this);
    document.onkeydown = this.resetTimer.bind(this);
  }

  resetTimer() {
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      if (this.authService.getAutoLogout() && this.authService.getToken()) {
        ls.remove('Authorization');
        ls.remove('Public-Key');
        ls.remove('client');
        ls.remove('X-Client-Id');
        ls.remove('client-name');
        this.store.dispatch(reduxReset());
        this.router.navigate(['/login']);
      }
    }, 300000); // 300,000= 5 min
  }

  ngAfterContentChecked() {
    this.ref.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    if (this.timer) {
      this.timer.clear();
    }
  }
}
